export function validateCard(card, resolve, reject) {
    window.Stripe.createToken(card, function(status, response) {            
        if(response.error) {
            reject(response.error);
        } else {
            resolve(response);
        }
    })
}